export default __webpack_public_path__ + "static/PlayfairDisplay-Regular-ab37fd8f8b17807ebb1ee531780891bc.ttf";